import React from 'react';
import { CustomToggleProps } from './types/CustomInputsTypes';

const CustomToggle: React.FC<CustomToggleProps> = ({
  label,
  description,
  checked,
  onChange,
  className = '',
}) => {
  return (
    <div className={`flex items-start justify-between ${className}`}>
      <div>
        <p className="text-xs font-semibold text-ds-gray-500">{label}</p>
        {description && <p className="text-xs text-ds-gray-300 mt-1">{description}</p>}
      </div>

      <label className="relative inline-flex items-center cursor-pointer ml-4 mt-1">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <div
          className={`
            w-[48px] h-[24px] rounded-full 
            transition-colors duration-300 
            ${checked ? 'bg-[#1ECB95]' : 'bg-[#B4B8D1]'}
          `}
        >
          <div
            className={`
              absolute top-[2px]
              w-[20px] h-[20px]
              bg-white rounded-full shadow-md
              transition-transform duration-300 ease-in-out
              ${checked ? 'translate-x-[24px]' : 'translate-x-[2px]'}
            `}
          />
        </div>
      </label>
    </div>
  );
};

export default CustomToggle;
